import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='13' height='20' viewBox='0 0 13 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.7354 13.8069L7.30692 19.2354C6.95407 19.5882 6.38047 19.5882 6.02762 19.2354L0.599177 13.8069C0.246328 13.4541 0.246328 12.8805 0.599177 12.5276C0.952026 12.1748 1.52563 12.1748 1.87848 12.5276L5.76162 16.4108L5.76163 1.40474C5.76163 0.905323 6.16695 0.5 6.66637 0.5C7.16578 0.5 7.57111 0.905323 7.57111 1.40474L7.5711 16.4108L11.4543 12.5276C11.6316 12.3503 11.8632 12.2634 12.0948 12.2634C12.3264 12.2634 12.558 12.3521 12.7354 12.5276C13.0882 12.8805 13.0882 13.4541 12.7354 13.8069Z'
      fill='white'
    />
  </svg>
)
